import { useCityStore } from "@/context";
import { ObjectToQueryParams } from "@/utils";
import { useState } from "react";
import useApi from "@/services/use.api";

const { useGetApi } = useApi();

export const useCities = () => {
  const [loading, setLoading] = useState(false);
  const { cities, regions, setCities, setRegions } = useCityStore();

  const fetchCities = async (region?: string, reset?: boolean) => {
    if (cities.length && !reset) return;
    setLoading(true);
    const param = ObjectToQueryParams({ region });
    const res = await useGetApi(
      region ? `/public/villes/${region}` : `/public/villes`
    );
    const { data } = res ?? {};
    if (data && Array.isArray(data)) {
      setCities((data ?? []).reverse());
    }
    setLoading(false);
  };

  const fetchRegionCities = async (region: string): Promise<string[]> => {
    setLoading(true);
    const param = ObjectToQueryParams({ region });
    const res = await useGetApi(`/public/villes/${region}`);
    const { data } = res ?? {};
    setLoading(false);
    if (data && Array.isArray(data)) {
      return (data ?? []).reverse();
    }

    return [];
  };

  const fetchRegions = async (reset?: boolean) => {
    if (regions.length && !reset) return;
    setLoading(true);
    const res = await useGetApi(`/public/regions`);
    const items = res?.data ?? [];
    if (items && Array.isArray(items)) {
      setRegions(items);
    }
    setLoading(false);
  };

  return {
    cities,
    regions,
    loading,
    fetchCities,
    fetchRegions,
    fetchRegionCities,
  };
};
